import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

export const ANALYTICS_EVENTS = {
  PAGE_VIEW: 'page_view',
  MARKETPLACE_VIEWED: 'marketplace_viewed',
  MARKETPLACE_SEARCH: 'marketplace_search',
  BEAT_PREVIEW: 'beat_preview',
  CHECKOUT_OPENED: 'begin_checkout',
  PAYMENT_SUCCESS: 'purchase',
  PAYMENT_FAILURE: 'payment_failure',
};

const MAX_STRING_LENGTH = 100;

const cleanString = (value) => value.trim().slice(0, MAX_STRING_LENGTH);

export const sanitizeAnalyticsParams = (params = {}) => Object.entries(params).reduce((cleaned, [key, value]) => {
  if (value === undefined || value === null || value === '') return cleaned;
  if (typeof value === 'number' && !Number.isFinite(value)) return cleaned;
  if (typeof value === 'string') {
    const nextValue = cleanString(value);
    if (nextValue) cleaned[key] = nextValue;
    return cleaned;
  }
  if (Array.isArray(value)) {
    const nextValue = value
      .map((item) => (typeof item === 'object' && item !== null ? sanitizeAnalyticsParams(item) : item))
      .filter((item) => item !== undefined && item !== null && item !== '');
    if (nextValue.length) cleaned[key] = nextValue;
    return cleaned;
  }
  if (typeof value === 'object') {
    const nextValue = sanitizeAnalyticsParams(value);
    if (Object.keys(nextValue).length) cleaned[key] = nextValue;
    return cleaned;
  }
  cleaned[key] = value;
  return cleaned;
}, {});

export const trackAnalyticsEvent = (eventName, params = {}) => {
  if (!analytics || !eventName) return false;

  try {
    logEvent(analytics, eventName, sanitizeAnalyticsParams(params));
    return true;
  } catch (error) {
    console.warn('Firebase Analytics event failed:', eventName, error);
    return false;
  }
};

const numericPrice = (price) => {
  const value = Number(String(price || 0).replace(/[^0-9.]/g, ''));
  return Number.isFinite(value) ? Number(value.toFixed(2)) : 0;
};

const firstGenre = (track = {}) => {
  if (Array.isArray(track.genres) && track.genres.length) return track.genres[0];
  return track.genre || 'Uncategorized';
};

export const buildBeatAnalyticsParams = (track = {}, extra = {}) => ({
  beat_id: track.id || '',
  genre: firstGenre(track),
  price: numericPrice(track.price),
  currency: 'USD',
  license_type: track.licenseType || 'standard',
  ...extra,
});

export const buildPurchaseAnalyticsParams = (track = {}, paymentIntentId = '', extra = {}) => {
  const price = numericPrice(track.price);

  return buildBeatAnalyticsParams(track, {
    transaction_id: paymentIntentId,
    value: price,
    items: [{
      item_id: track.id || '',
      item_category: firstGenre(track),
      price,
      quantity: 1,
    }],
    ...extra,
  });
};
